import { Typography, Stack, Chip, Divider } from "@mui/material";


const CrewList = ({ crewMembers }) => {
    if (!crewMembers?.length) return (
        <Typography variant="caption" color="text.disabled" display="block" mb={1}>
            No crew members recorded.
        </Typography>
    );
    return (
        <>
            <Divider sx={{ my: 1 }} />
            <Typography variant="caption" color="text.secondary" display="block" mb={0.5}>
                Crew Members
            </Typography>
            {crewMembers.map((m, i) => (
                <Stack key={i} direction="row" alignItems="center" spacing={1} sx={{ py: 0.25 }}>
                    <Typography variant="caption" fontWeight={600}>{m.crewCode}</Typography>
                    <Typography variant="caption" sx={{ flex: 1 }}>{m.crewName}</Typography>
                    {m.post && <Chip label={m.post} size="small" sx={{ height: 16, fontSize: "0.65rem" }} />}
                    {m.base && <Typography variant="caption" color="text.secondary">{m.base}</Typography>}
                </Stack>
            ))}
        </>
    );
};

export default CrewList;
